import { call } from "../helpers/axiosInterceptor";

const createCourse = async (payload: any) => {
  try {
    const { data } = await call.post("course/create", { ...payload },
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("refToken"),
        }
      },);

    return data;
  } catch (e) {

  }
};

const getCourses = async () => {
  try {
    const { data } = await call.get("course/list",
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("refToken"),
        }
      },);
    return data;
  } catch (e) {

  }
};

const updateCourse = async (payload: any) => {
  try {
    const { data } = await call.post("course/update", { ...payload },
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("refToken"),
        }
      },);
    return data;
  } catch (e) {

  }
};

const getCoursesById = async (id: any) => {
  try {
    
    const { data } = await call.get(`course/list/${id}`,
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("refToken"),
        }
      },);
    return data;
  } catch (e) {

  }
};

const getCoursesBysearch = async (query: any) => {
  try {
    const { data } = await call.get(`course/search/${query}`,
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("refToken"),
        }
      },);
    return data;
  } catch (e) {

  }
};

const deleteCourse = async (courseId: string) => {
  try {
    const response = await call.delete(`/course/delete/${courseId}`, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("refToken"),
      },
    });
  } catch (e: any) {
    console.error("Error deleting course:", e.response?.data?.message || e.message);
  }
};

export {
  createCourse,
  getCourses,
  getCoursesById,
  updateCourse,
  getCoursesBysearch,
  deleteCourse,
};
